"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const PropTypes = __importStar(require("prop-types"));
const React = __importStar(require("react"));
const clsx_1 = require("clsx");
const propTypesUtils_1 = require("../utils/propTypesUtils");
const Header_1 = __importDefault(require("./Header"));
const eventUtils_1 = require("../../common/eventUtils");
const dateConstants_1 = require("../utils/dateConstants");
const dateUtils_1 = require("../utils/dateUtils");
const matchDayUtils_1 = require("../utils/matchDayUtils");
const date_fns_1 = require("date-fns");
class DayPicker extends React.Component {
    constructor(props) {
        super(props);
        this.dayPicker = null;
        this.state = {
            today: (0, date_fns_1.startOfToday)(),
            currentMonth: props.month || props.selectedDays || new Date(),
            showTooltip: false,
            currentID: ''
        };
        this.handleKeyDownContainer = this.handleKeyDownContainer.bind(this);
        this.handleKeyDownFooter = this.handleKeyDownFooter.bind(this);
    }
    componentDidUpdate(prevProps) {
        // Changing the `month` props means changing the current displayed month
        if (prevProps.month !== this.props.month) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ currentMonth: this.props.month || new Date() });
        }
    }
    focusCell(index) {
        if (index) {
            if (this.dayPicker) {
                const dayNodes = this.dayPicker.querySelectorAll(dateConstants_1.DAYS_SELECTOR);
                dayNodes[index - 1].focus();
            }
        }
    }
    getEnabledCell(index, action, maxStepCheck) {
        const dayNodes = this.dayPicker.querySelectorAll(dateConstants_1.DAYS_VISIBLE_SELECTOR);
        const currentCell = dayNodes[index - 1];
        const siblingDirection = action === 'next' ? 'nextElementSibling' : 'previousElementSibling';
        return (0, dateUtils_1.getSiblingOrCurrent)(currentCell, dateConstants_1.DAYS_ENABLED_SELECTOR, siblingDirection, maxStepCheck);
    }
    focusOnlyEnabledCell(date, action, maxStepCheck, needToChangeMonth = true) {
        const { locale } = this.props;
        const index = date.getDate();
        if (index) {
            if (this.dayPicker) {
                const enabledCell = this.getEnabledCell(index, action, maxStepCheck);
                if (enabledCell) {
                    enabledCell.focus();
                }
                else {
                    if (needToChangeMonth) {
                        // when called through arrow navigation
                        // when changing month, focus the first available date, if exists
                        const step = action === 'next' ? 1 : -1;
                        const nextMonth = (0, date_fns_1.addMonths)(date, step);
                        this.setState({ currentMonth: nextMonth }, () => {
                            // we need to use the callback to be sure the date picker is re-rendered with the new month
                            const index = action === 'next' ? 1 : (0, date_fns_1.endOfMonth)(nextMonth).getDate();
                            const enabledCell = this.getEnabledCell(index, action, maxStepCheck);
                            if (enabledCell) {
                                enabledCell.focus();
                            }
                            else {
                                // if all cell are disabled, focus the first day of month
                                this.focusCell((0, dateUtils_1.getBoundedDay)((0, date_fns_1.startOfMonth)(nextMonth), nextMonth, locale));
                            }
                        });
                    }
                    else {
                        // when called through ARROWS navigation
                        this.focusCell((0, dateUtils_1.getBoundedDay)((0, date_fns_1.startOfMonth)(date), date, locale));
                    }
                }
            }
        }
    }
    monthNavigation(date, nextDate) {
        const { locale } = this.props;
        this.setState({ currentMonth: nextDate }, () => this.focusCell((0, dateUtils_1.getBoundedDay)(date, nextDate, locale)));
    }
    arrowNavigation(date, nextDate) {
        const delta = (0, date_fns_1.differenceInCalendarMonths)(nextDate, date);
        const action = (0, date_fns_1.isBefore)(date, nextDate) ? 'next' : 'previous';
        if (delta !== 0) {
            this.setState({ currentMonth: nextDate }, () => this.focusOnlyEnabledCell(nextDate, action, null, false));
        }
        else {
            this.focusOnlyEnabledCell(nextDate, action, null);
        }
    }
    handleKeyDownContainer(e) {
        const { onClose } = this.props;
        switch (e.key) {
            case eventUtils_1.Keys.ESC:
                onClose();
            // eslint-disable-next-line no-fallthrough
            case eventUtils_1.Keys.PAGE_DOWN:
            case eventUtils_1.Keys.PAGE_UP:
            case eventUtils_1.Keys.HOME:
            case eventUtils_1.Keys.END:
            case eventUtils_1.Keys.ARROW_LEFT:
            case eventUtils_1.Keys.ARROW_UP:
            case eventUtils_1.Keys.ARROW_RIGHT:
            case eventUtils_1.Keys.ARROW_DOWN:
                (0, eventUtils_1.cancelEvent)(e);
                break;
        }
    }
    handleKeyDownCell(e, date, modifers) {
        const { locale, dir } = this.props;
        const { currentMonth } = this.state;
        if (e.key !== eventUtils_1.Keys.ESC) {
            (0, eventUtils_1.cancelEvent)(e);
        }
        const direction = dir === 'ltr' ? 1 : -1;
        const MAX_STEP_TO_CHECK = 7;
        let nextCell;
        switch (e.key) {
            case eventUtils_1.Keys.TAB:
                if (this.dayPicker) {
                    if (e.shiftKey) {
                        this.dayPicker
                            .querySelector('.tk-daypicker-header--nextYear')
                            .focus();
                    }
                    else {
                        this.dayPicker.querySelector('.tk-daypicker-today').focus();
                    }
                }
                break;
            case eventUtils_1.Keys.SPACE:
            case eventUtils_1.Keys.SPACEBAR:
            case eventUtils_1.Keys.ENTER:
                // eslint-disable-next-line no-case-declarations
                const { onDayClick } = this.props;
                onDayClick(date, modifers);
                break;
            case eventUtils_1.Keys.PAGE_UP:
                if (e.shiftKey) {
                    this.monthNavigation(date, (0, date_fns_1.addYears)(currentMonth, -1));
                }
                else {
                    this.monthNavigation(date, (0, date_fns_1.addMonths)(currentMonth, -1));
                }
                break;
            case eventUtils_1.Keys.PAGE_DOWN:
                if (e.shiftKey) {
                    this.monthNavigation(date, (0, date_fns_1.addYears)(currentMonth, 1));
                }
                else {
                    this.monthNavigation(date, (0, date_fns_1.addMonths)(currentMonth, 1));
                }
                break;
            case eventUtils_1.Keys.HOME:
                // eslint-disable-next-line no-case-declarations
                const firstDayOfWeek = (0, date_fns_1.startOfWeek)(date, { locale });
                nextCell =
                    firstDayOfWeek.getDate() <= date.getDate()
                        ? firstDayOfWeek
                        : (0, date_fns_1.startOfMonth)(date);
                this.focusOnlyEnabledCell(nextCell, 'next', MAX_STEP_TO_CHECK);
                break;
            case eventUtils_1.Keys.END:
                // eslint-disable-next-line no-case-declarations
                const lastDayOfWeek = (0, date_fns_1.endOfWeek)(date, { locale });
                nextCell =
                    date.getDate() <= lastDayOfWeek.getDate()
                        ? lastDayOfWeek
                        : (0, date_fns_1.lastDayOfMonth)(date);
                this.focusOnlyEnabledCell(nextCell, 'previous', MAX_STEP_TO_CHECK);
                break;
            case eventUtils_1.Keys.ARROW_LEFT:
                this.arrowNavigation(date, (0, date_fns_1.addDays)(date, -1 * direction));
                break;
            case eventUtils_1.Keys.ARROW_UP:
                this.arrowNavigation(date, (0, date_fns_1.addDays)(date, -7));
                break;
            case eventUtils_1.Keys.ARROW_RIGHT:
                this.arrowNavigation(date, (0, date_fns_1.addDays)(date, 1 * direction));
                break;
            case eventUtils_1.Keys.ARROW_DOWN:
                this.arrowNavigation(date, (0, date_fns_1.addDays)(date, 7));
                break;
            default:
                break;
        }
    }
    handleKeyDownFooter(e) {
        switch (e.key) {
            case eventUtils_1.Keys.TAB:
                if (!e.shiftKey) {
                    (0, eventUtils_1.cancelEvent)(e);
                    if (this.dayPicker) {
                        this.dayPicker
                            .querySelector('.tk-daypicker-header--prevYear')
                            .focus();
                    }
                }
                break;
            case eventUtils_1.Keys.SPACE:
            case eventUtils_1.Keys.SPACEBAR:
            case eventUtils_1.Keys.ENTER:
                (0, eventUtils_1.cancelEvent)(e);
                // eslint-disable-next-line no-case-declarations
                const { disabledDays, onDayClick } = this.props;
                // eslint-disable-next-line no-case-declarations
                const { today } = this.state;
                onDayClick(today, { disabled: (0, matchDayUtils_1.matchDay)(today, disabledDays) });
                break;
        }
    }
    // Create WeekDayHeader
    renderSubHeader(weekdaysShort, weekdaysLong, dir) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "tk-daypicker-weekday", role: "row", style: { direction: dir }, children: weekdaysShort.map((day, index) => ((0, jsx_runtime_1.jsx)("div", { className: "tk-daypicker-weekday--text", role: "columnheader", title: weekdaysLong[index], children: day }, index))) }));
    }
    renderOutsideDay(days) {
        return (0, dateUtils_1.toArray)(days).map((cell) => {
            return ((0, jsx_runtime_1.jsx)("div", { "aria-selected": "false", className: "tk-daypicker-day--outside", tabIndex: -1 }, `day-outside-${cell}`));
        });
    }
    renderBody() {
        const { dir, locale, selectedDays, disabledDays, highlightedDays, onDayClick, } = this.props;
        const { today, currentMonth } = this.state;
        const daysInMonth = (0, date_fns_1.getDaysInMonth)(currentMonth);
        const daysNeededForLastMonth = (0, dateUtils_1.getDaysNeededForLastMonth)(currentMonth, locale);
        const daysNeededForNextMonth = (0, dateUtils_1.getDaysNeededForNextMonth)(currentMonth, locale);
        const selectedDateString = selectedDays
            ? (0, date_fns_1.lightFormat)(selectedDays, 'yyyy-MM-dd')
            : null;
        const todayDateString = (0, date_fns_1.lightFormat)(today, 'yyyy-MM-dd');
        const isSelectedDayVisible = selectedDays &&
            (0, date_fns_1.differenceInCalendarMonths)(selectedDays, currentMonth) === 0;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "tk-daypicker-body", role: "grid", style: { direction: dir }, children: [this.renderOutsideDay(daysNeededForLastMonth), (0, dateUtils_1.toArray)(daysInMonth).map((cell) => {
                    const cellNumber = cell + 1;
                    const cellDate = (0, date_fns_1.setDate)(currentMonth, cellNumber);
                    const cellName = (0, dateUtils_1.formatDay)(cellDate, locale);
                    const itemDateString = (0, date_fns_1.lightFormat)(cellDate, 'yyyy-MM-dd');
                    const isSelected = itemDateString === selectedDateString;
                    const isToday = itemDateString === todayDateString;
                    const isDisabled = (0, matchDayUtils_1.matchDay)(cellDate, disabledDays);
                    const isHighlighted = (0, matchDayUtils_1.matchDay)(cellDate, highlightedDays);
                    const ariaSelected = isDisabled ? undefined : isSelected;
                    const isTabIndex = isSelectedDayVisible
                        ? isSelected
                            ? 0
                            : -1
                        : isToday
                            ? 0
                            : -1; // focus on selected day otherwise current day
                    return ((0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.clsx)('tk-daypicker-day', {
                            'tk-daypicker-day--selected': isSelected,
                        }, {
                            'tk-daypicker-day--today': isToday,
                        }, {
                            'tk-daypicker-day--highlighted': isHighlighted && !isDisabled,
                        }, { 'tk-daypicker-day--disabled': isDisabled }), role: "gridcell", "aria-label": cellName, "aria-selected": ariaSelected, tabIndex: isTabIndex, onKeyDown: (e) => this.handleKeyDownCell(e, cellDate, {
                            disabled: isDisabled,
                            selected: isSelected,
                        }), onClick: () => onDayClick(cellDate, {
                            disabled: isDisabled,
                            selected: isSelected,
                        }), children: cellNumber }, cellName));
                }), this.renderOutsideDay(daysNeededForNextMonth)] }));
    }
    renderFooter() {
        const { todayButton, onDayClick } = this.props;
        const { today } = this.state;
        return ((0, jsx_runtime_1.jsx)("div", { className: "tk-daypicker-footer", children: (0, jsx_runtime_1.jsx)("span", { className: "tk-daypicker-today", tabIndex: 0, "aria-label": todayButton, role: "button", onClick: () => onDayClick(today, {}), onKeyDown: this.handleKeyDownFooter, children: todayButton }) }));
    }
    render() {
        const { dir, labels, locale, dataTestId } = this.props;
        const { currentMonth, showTooltip, currentID } = this.state;
        const now = new Date();
        return ((0, jsx_runtime_1.jsxs)("div", { className: "tk-daypicker", "data-testid": dataTestId, ref: (el) => (this.dayPicker = el), onKeyDown: this.handleKeyDownContainer, children: [(0, jsx_runtime_1.jsx)(Header_1.default, { date: currentMonth, dir: dir, months: (0, dateUtils_1.getMonths)(now, locale), showTooltip: showTooltip, currentID: currentID, onChange: (month) => this.setState({ currentMonth: month }), onVisible: (id) => this.setState({ showTooltip: true, currentID: id }), onClose: () => this.setState({ showTooltip: false, currentID: '' }), labels: labels, parentRef: this.dayPicker }), this.renderSubHeader((0, dateUtils_1.getWeekdaysShort)(now, locale), (0, dateUtils_1.getWeekdaysLong)(now, locale), dir), this.renderBody(), this.renderFooter()] }));
    }
}
DayPicker.propTypes = {
    dir: PropTypes.oneOf(['rtl', 'ltr']),
    disabledDays: PropTypes.oneOfType(propTypesUtils_1.modifierPropTypes),
    format: PropTypes.string,
    highlightedDays: PropTypes.oneOfType(propTypesUtils_1.modifierPropTypes),
    labels: PropTypes.exact({
        previousYear: PropTypes.string,
        previousMonth: PropTypes.string,
        nextYear: PropTypes.string,
        nextMonth: PropTypes.string,
    }),
    locale: PropTypes.any,
    month: PropTypes.instanceOf(Date),
    selectedDays: PropTypes.instanceOf(Date),
    todayButton: PropTypes.string,
    onClose: PropTypes.func,
    onDayClick: PropTypes.func,
};
exports.default = DayPicker;
